import type { HomeMoversSide } from '@/features/home/api/homeSchemas'

export const homeKeys = {
  all: ['home'] as const,
  movers: (side: HomeMoversSide) => [...homeKeys.all, 'movers', side] as const,
}
